import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useSenderEmails = () => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["senderEmails", tenantVal],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/practicesettings/senderemails`
      );
      return response.data || [];
    },
    enabled: !!tenantVal,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    throwOnError: false,
    meta: { skipGlobalError: true },
  });
};
